import { useEffect, useState } from "react";
import api from "../../../utils/axiosInstance";
import SystemValueTable, { VendorCodeCell } from "./SystemValueTable";

const langPairLabel = (row) => {
  const src = row.languagePair?.sourceLanguage?.code;
  const tgt = row.languagePair?.targetLanguage?.code;
  return src && tgt ? `${src} → ${tgt}` : "—";
};

const columns = [
  {
    header: "Vendor",
    render: (row) => (
      <VendorCodeCell vendorId={row.vendor?.id || row.vendor_id} />
    ),
  },
  { header: "Language Pair", render: langPairLabel },
];

const LanguagePairsPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/vendor-language-pairs", {
          withCredentials: true,
        });
        setRows(res.data.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch language pairs");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return <div className="text-center mt-10 text-gray-500">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-600">{error}</div>;

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold text-gray-900">Language Pairs</h1>
      <p className="text-sm text-gray-600">
        Showing <span className="font-semibold">{rows.length}</span> items.
      </p>
      <SystemValueTable
        columns={columns}
        rows={rows}
        emptyText="No vendor language pairs found."
      />
    </div>
  );
};

export default LanguagePairsPage;
